import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9c1e476"),n=n(),_popScopeId(),n)
const _hoisted_1 = { slot: "collapse-summary" }
const _hoisted_2 = { class: "collapse-summary" }
const _hoisted_3 = { class: "collapse-item-summary_title" }
const _hoisted_4 = { slot: "collapse-marker" }
const _hoisted_5 = { slot: "collapse-detail" }
const _hoisted_6 = { class: "collapse-detail" }
const _hoisted_7 = { class: "functional-skill-additional" }

import {array, number} from 'vue-types';
    import {computed, reactive, toRef} from 'vue';
    import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';
    import {useTranslation} from '@malt/vue3-use';
    import {Tag} from '@/profile-creation-wizard/components/for-creation/Tag';
    import SelectedTags from '@/profile-creation-wizard/components/for-creation/ui/SelectedTags.vue';
    import InputSelectTags from '@/profile-creation-wizard/components/for-creation/ui/InputSelectTags.vue';
    import {FunctionalScope, FunctionalSkill} from '@/profile-creation-wizard/types';

    type FunctionalSkillEvents = {
        (e: 'functional-skills:updated', skills: string[]): void;
        (e: 'global-skills:added', skills: Tag): void;
        (e: 'global-skills:removed', skills: Tag): void;
    };
    
export default /*#__PURE__*/_defineComponent({
  __name: 'FunctionalSkills',
  props: {
        availableFunctionalScopes: array<FunctionalScope>().isRequired,
        selectedSkills: array<FunctionalSkill>().isRequired,
        globalSkills: array<Tag>().isRequired,
        maxFunctionalSkills: number().isRequired,
        maxGlobalSkills: number().isRequired,
    },
  emits: ["functional-skills:updated", "global-skills:added", "global-skills:removed"],
  setup(__props, { emit }) {

const props = __props;

    const {msg} = useTranslation();

    
    

    const state = reactive<{
        selectedSkills: FunctionalSkill[];
        globalSkills: Tag[];
        availableFunctionalScopes: FunctionalScope[];
        scopeOpened: string[];
    }>({
        selectedSkills: toRef(props, 'selectedSkills'),
        globalSkills: toRef(props, 'globalSkills'),
        availableFunctionalScopes: toRef(props, 'availableFunctionalScopes'),
        scopeOpened: [],
    });

    const isMaxSkillsSelected = computed(() => state.selectedSkills.length >= props.maxFunctionalSkills);

    const isSkillSelected = computed(() => (skill: FunctionalSkill) => {
        return state.selectedSkills.some((selectedSkill) => selectedSkill.humanId === skill.humanId);
    });

    function isCounterDisplayable(scope: FunctionalScope) {
        return countSelectedFunctionalSkillsByScope(scope) > 0;
    }

    function countSelectedFunctionalSkillsByScope(scope: FunctionalScope) {
        return scope.functionalSkills.filter((skill) =>
            state.selectedSkills.some((selectedSkill: FunctionalSkill) => skill.humanId === selectedSkill.humanId),
        ).length;
    }

    function isCollapseOpened(scope: FunctionalScope) {
        return state.scopeOpened.includes(scope.label);
    }

    function rotateChevronIcon(scope: FunctionalScope) {
        return isCollapseOpened(scope) ? 'functional-skill-chevron-down' : '';
    }

    function handleSelectedSkillsChanged(event: CustomEvent, skillSelected: FunctionalSkill) {
        if (event.detail.selected) {
            state.selectedSkills.push(skillSelected);
        } else {
            state.selectedSkills = state.selectedSkills.filter((selectedSkill) => selectedSkill.humanId !== skillSelected.humanId);
        }
        emit('functional-skills:updated', state.selectedSkills);
    }

    function handleMaxSelectedSkills(event) {
        const skillSelected = event.target.selected;
        if (isMaxSkillsSelected.value && !skillSelected) {
            pushNotification(msg('profile.creation.completion.wizard.functionalSkills.error.limit', props.maxFunctionalSkills), {
                level: 'error',
            });
        }
    }

    function handleCollapseOpen(scopeLabel: string) {
        state.scopeOpened.push(scopeLabel);
    }

    function handleCollapseClose(scopeLabel: string) {
        state.scopeOpened = state.scopeOpened.filter((scopeOpened) => scopeOpened !== scopeLabel);
    }

    function selectSearch(tag: Tag): void {
        if (!tag || !tag.name || tag.name.length == 0) {
            return;
        }
        pushTag(tag);
    }

    function pushTag(tag: Tag): void {
        if (state.globalSkills.length >= props.maxGlobalSkills) {
            pushNotification(msg('profile.creation.completion.wizard.details.skills.error.max'), {level: 'error'});
            return;
        }
        if (state.globalSkills.some((s: Tag) => sanitize(s.name) === sanitize(tag.name))) {
            pushNotification(msg('profile.creation.completion.wizard.details.skills.error.duplicate'), {level: 'error'});
            return;
        }
        emit('global-skills:added', tag);
    }

    function sanitize(value: string): string {
        if (!value) {
            return '';
        }

        return value
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
    }

    function handlerRemoveTag(tag: Tag): void {
        emit('global-skills:removed', tag);
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_tag = _resolveComponent("joy-tag")!
  const _component_joy_icon = _resolveComponent("joy-icon")!
  const _component_joy_tags_list = _resolveComponent("joy-tags-list")!
  const _component_joy_collapse_item = _resolveComponent("joy-collapse-item")!
  const _component_joy_collapse = _resolveComponent("joy-collapse")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_joy_collapse, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.availableFunctionalScopes, (scope, indexScope) => {
            return (_openBlock(), _createBlock(_component_joy_collapse_item, {
              key: `${indexScope}_${scope.label}`,
              class: _normalizeClass(["collapse-item", {'collapse-item-open': isCollapseOpened(scope)}]),
              "data-testid": `functional-scope-${indexScope}`,
              onJoyCollapseItemOpen: ($event: any) => (handleCollapseOpen(scope.label)),
              onJoyCollapseItemClose: ($event: any) => (handleCollapseClose(scope.label))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(scope.label), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    (isCounterDisplayable(scope))
                      ? (_openBlock(), _createBlock(_component_joy_tag, {
                          key: 0,
                          class: "collapse-marker_counter",
                          "data-testid": `functional-skill-counter-${indexScope}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(countSelectedFunctionalSkillsByScope(scope)), 1)
                          ]),
                          _: 2
                        }, 1032, ["data-testid"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_joy_icon, {
                      class: _normalizeClass(["functional-skill-chevron", rotateChevronIcon(scope)]),
                      name: "chevron-top"
                    }, null, 8, ["class"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_joy_tags_list, { class: "collapse-detail_tag-lists" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.functionalSkills, (skill, indexSkill) => {
                          return (_openBlock(), _createBlock(_component_joy_tag, {
                            key: skill.humanId,
                            selected: isSkillSelected.value(skill),
                            variant: "secondary",
                            selectable: !isMaxSkillsSelected.value || isSkillSelected.value(skill),
                            "data-testid": `${indexScope}-functional-skill-${indexSkill}`,
                            onClick: handleMaxSelectedSkills,
                            onJoyTagClick: (event) => handleSelectedSkillsChanged(event, skill)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(skill.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["selected", "selectable", "data-testid", "onJoyTagClick"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["class", "data-testid", "onJoyCollapseItemOpen", "onJoyCollapseItemClose"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("p", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.functionalSkills.additionalSkills.title')), 1),
      _createVNode(InputSelectTags, {
        id: "keywords_enhanced",
        class: "skills__autocomplete",
        placeholder: "profile.creation.completion.wizard.functionalSkills.additionalSkills.placeholder",
        "onUpdate:tag": selectSearch
      }),
      _createVNode(SelectedTags, {
        tags: state.globalSkills,
        onRemove: handlerRemoveTag
      }, null, 8, ["tags"])
    ])
  ], 64))
}
}

})